// extracted by mini-css-extract-plugin
export var copy = "peopleValues-module--copy--19-N9";
export var title = "peopleValues-module--title--3Fzw5";
export var box = "peopleValues-module--box--1F5Lf";